import { gql } from '@apollo/client';

export const CREATE_VIRTUAL_USER_PROFILE_MUTATION = gql`
  mutation CreateVirtualHotelUserProfile($data: VirtualHotelUserInput!) {
    createVirtualHotelUser(input: { data: $data }) {
      virtualHotelUser {
        id
        fullName
        profilePicture {
          id
          url
          formats
        }
      }
    }
  }
`;
